module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('smallBar', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [(_vm.company.user_permission == 'admin') ? _c('button', {
    staticClass: "btn btn-default btn-new v-team-step-0-3",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.CreateEmployeeModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增人員")]) : _vm._e(), _vm._v(" "), (1 == 2) ? _c('div', {
    staticClass: "j-forms inline-block pull-right"
  }, [_c('label', {
    staticClass: "radio-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.deal_require_permission),
      expression: "company.deal_require_permission"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.deal_require_permission) ? _vm._i(_vm.company.deal_require_permission, null) > -1 : (_vm.company.deal_require_permission)
    },
    on: {
      "change": _vm.update_deal_require_permission,
      "__c": function($event) {
        var $$a = _vm.company.deal_require_permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.company.deal_require_permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.company.deal_require_permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.company.deal_require_permission = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', {
    staticClass: "white-word"
  }, [_vm._v("只有主管可以看到所有人的交易，分析，與代辦事項。")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.company.name))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('h5', {
    staticClass: "text-gray pointer",
    on: {
      "click": function($event) {
        _vm.adminIntroModal = true
      }
    }
  }, [_c('small', [_vm._v("主管權限？")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table v-team-step-0-2 table-striped table-middle"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("人員")]), _vm._v(" "), _c('th', [_vm._v("職稱")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("每月業績目標")]), _vm._v(" "), _c('th', [_vm._v("用戶到期日")]), _vm._v(" "), _c('th', [_vm._v("權限")]), _vm._v(" "), (_vm.company.user_permission == 'admin') ? _c('th') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.company.employees), function(employee) {
    return _c('tr', {
      attrs: {
        "align": "left"
      }
    }, [_c('td', [_c('img', {
      staticClass: "avatar-size",
      attrs: {
        "src": employee.user_profile_pic || '/static/avatar-default.jpg'
      }
    }), _vm._v(_vm._s(employee.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(employee.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(employee.email))]), _vm._v(" "), (employee.sales_target == 0 || employee.sales_target == null) ? _c('td', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.editNewTarget(employee)
        }
      }
    }, [_vm._v("無每月目標")]) : _vm._e(), _vm._v(" "), (employee.sales_target != 0 && employee.sales_target != null) ? _c('td', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.checkEmployeeSalesTargets(employee)
        }
      }
    }, [_vm._v(_vm._s(employee.sales_target.toLocaleString()) + " "), _c('i', {
      staticClass: "fa fa-cog"
    })]) : _vm._e(), _vm._v(" "), (employee.permission == 'admin') ? _c('td', [_vm._v("主管\n                  ")]) : _vm._e(), _vm._v(" "), (employee.permission == 'general') ? _c('td', [_vm._v("一般\n                  ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(employee.expired_at))]), _vm._v(" "), (_vm.company.user_permission == 'admin') ? _c('td', [_c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          _vm.UpdateEmployeeModal = true;
          _vm.update_employee = employee;
          _vm.employee_permission_cache = employee.permission
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          _vm.destroyEployee(employee)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }))])])])])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), (_vm.CreateEmployeeModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.CreateEmployeeModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.CreateEmployeeModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.CreateEmployeeModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("邀請你的夥伴進入你的團隊，跟你一起工作！")]), _vm._v(" "), _c('p', [_vm._v("1. 請你的夥伴，建立一個新帳號，同時他將擁有30天免費體驗！")]), _vm._v(" "), _c('p', [_vm._v("2. 在下方輸入夥伴Email，送出邀請網址")]), _vm._v(" "), _c('p', [_vm._v("3. 請夥伴到信箱、收取團隊邀請，即可加入團隊囉！")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入正確Email格式")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                新增\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.CreateEmployeeModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadLogoModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              上傳新的LOGO\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/settings/update_company',
      "headers": _vm.auth_token,
      "maxFileSizeInMB": 12
    },
    on: {
      "vdropzone-success": _vm.vsuccess
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.UpdateEmployeeModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.UpdateEmployeeModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.UpdateEmployeeModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("夥伴名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update_employee.name),
      expression: "update_employee.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.update_employee.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.update_employee.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update_employee.email),
      expression: "update_employee.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.update_employee.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.update_employee.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("職稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update_employee.title),
      expression: "update_employee.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "職稱"
    },
    domProps: {
      "value": (_vm.update_employee.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.update_employee.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("預設的每月業績")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update_employee.sales_target),
      expression: "update_employee.sales_target"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "業績目標",
      "name": "sales_target"
    },
    domProps: {
      "value": (_vm.update_employee.sales_target)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.update_employee.sales_target = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("團隊權限（主管將可以編輯所有人的各種資料）")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employee_permission_cache),
      expression: "employee_permission_cache"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employee_permission_cache = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "admin"
    }
  }, [_vm._v("主管")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "general"
    }
  }, [_vm._v("一般")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.UpdateEmployee(_vm.update_employee)
      }
    }
  }, [_vm._v("\n                更新\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.UpdateEmployeeModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.UpdateSalesTargetModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.UpdateSalesTargetModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.UpdateSalesTargetModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header text-center"
  }, [_c('h4', {
    staticClass: "text-center col-12"
  }, [_vm._v("\n              " + _vm._s(_vm.checked_employee.name) + "的 " + _vm._s(_vm._f("moment")(new Date(), "YYYY")) + " 業績目標\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body scroll"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_c('h5', [_vm._v("目標：$" + _vm._s(_vm.totalTarget.toLocaleString()) + " , 達成：$" + _vm._s(_vm.totalAmount.toLocaleString()) + " , 達成率：" + _vm._s(parseInt(_vm.totalAmount * 100 / _vm.totalTarget)) + "%")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.filterTargets), function(target) {
    return _c('tr', {
      class: {
        'table-success': _vm.thisMonth(target)
      }
    }, [_c('td', [_vm._v(_vm._s(target.month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(target.deal_number))]), _vm._v(" "), _c('td', [(_vm.target_edit == 'no' || _vm.target_edit != ('target_value' + target.id)) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.editTextClick(('target_value' + target.id), target)
        }
      }
    }, [_vm._v("$" + _vm._s(target.deal_amount.toLocaleString()) + " / $" + _vm._s(target.target.toLocaleString()) + " "), _c('i', {
      staticClass: "fa fa-pen"
    })]) : _vm._e(), _vm._v(" "), (_vm.target_edit == ('target_value' + target.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.temp_target),
        expression: "temp_target"
      }],
      ref: ('target_value' + target.id),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.temp_target)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.saveTarget(target)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.temp_target = $event.target.value
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(target.target != 0) ? _c('span', [_vm._v(_vm._s(parseInt(target.deal_amount * 100 / target.target)) + "%")]) : _c('span', [_vm._v("-")])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.UpdateSalesTargetModal = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.adminIntroModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.adminIntroModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.adminIntroModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.adminIntroModal = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("新增工作夥伴")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-center"
  }, [_c('h4', {
    staticClass: "text-center col-12"
  }, [_vm._v("\n              更新夥伴資料\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("月份")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("達成件數")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("達成金額/目標")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("月達成率")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-center"
  }, [_c('h4', {
    staticClass: "text-center col-12"
  }, [_vm._v("\n              主管權限 vs 一般權限\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("主管權限")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("一般權限")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("成員設定")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td', [_vm._v("僅能瀏覽"), _c('br'), _vm._v("無法邀請與變更")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("任務設定")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("公司設定")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("階段設定")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("付款設定")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("帳單一覽")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("變更瀏覽權限"), _c('br'), _vm._v("(所有成員可以看到彼此訂單，或是只能看到自己)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1fff9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/Members.vue
// module id = 670
// module chunks = 4